module.exports = __webpack_public_path__ + "rw-widgets.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/react-widgets/fonts/rw-widgets.eot
 ** module id = 567
 ** module chunks = 0
 **/